import { AgentAction } from "./types";

// FastAPI errors come back as `{ detail }` where `detail` is either a plain
// string or an object carrying `.message` (e.g. the EMAIL_DOMAIN_NOT_PERMITTED
// allowlist rejection). Surface that instead of a generic fallback.
export const getResponseErrorMessage = (body: unknown, fallback: string): string => {
  const detail = (body as { detail?: unknown })?.detail;
  if (typeof detail === "string" && detail) return detail;
  if (detail !== null && typeof detail === "object") {
    const { message } = detail as { message?: unknown };
    if (typeof message === "string" && message) return message;
  }
  return fallback;
};

// The axios interceptor / fetch handlers reject with the backend `detail`:
// either a string or an object carrying `.message` (e.g. the
// EMAIL_DOMAIN_NOT_PERMITTED allowlist rejection). Surface that over a fallback.
export const getErrorMessage = (error: unknown, fallback: string): string => {
  if (typeof error === "string" && error) return error;
  if (typeof error === "object" && error !== null && "message" in error) {
    const { message } = error as { message: unknown };
    if (typeof message === "string" && message) return message;
  }
  return fallback;
};

export const addOrUpdateAction = (actions: AgentAction[], action: AgentAction) => {
  const existingAction = actions.find(a => action.id && a.id === action.id);
  if (existingAction) {
    if (action.type === "analysis") {
      // analysis is streamed, so we need to append to the existing action
      return [
        ...actions.filter(a => a.id !== action.id),
        { ...existingAction, content: existingAction.content + action.content },
      ];
    }
    return [...actions.filter(a => a.id !== action.id), action];
  }
  return [...actions, action];
};
